





































































































































import Vue, { PropType } from "vue";
import RequiredLabel from "./../interface/RequiredLabel.vue";
import { maxLength, requiredIf } from "vuelidate/lib/validators";
import DossierLabels from "./../mijnDossier/DossierLabels.js";

import { Address } from "../../types/dossier/Address";

import DateInput from "./DateInput.vue";
import CountryInput from "./CountryInput.vue";
import CityInput from "./CityInput.vue";
import DeleteButton from "./../interface/DeleteButton.vue";

export default Vue.extend({
  name: "address-input",
  components: {
    DateInput,
    DeleteButton,
    CountryInput,
    CityInput,
    RequiredLabel,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Object as PropType<Address>,
      required: true,
    },
    selectValues: {
      type: Array,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isDirty: {
      type: Boolean,
      default: false,
      required: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      labels: DossierLabels,
    };
  },
  computed: {
    selectedAdres(): Address {
      return this.value;
    },
    isInBelgium(): boolean {
      return this.selectedAdres.land.land == "België";
    },
    isRequired(): boolean {
      //return this.$v.hasOwnProperty("required");
      return Object.prototype.hasOwnProperty.call(this.$v, "required");
    },
  },
  validations: {
    selectedAdres: {
      straat: {
        maxLength: maxLength(50),
      },
      nr: {
        requiredIf: requiredIf((object) => {
          return object.straat !== "";
        }),
      },
      bus: {},
      hfdPostnr: {
        requiredIf: requiredIf((object) => {
          return object.straat !== "";
        }),
      },
      deelgemeente: {
        requiredIf: requiredIf((object) => {
          return object.straat !== "";
        }),
      },
      land: {
        requiredIf: requiredIf((object) => {
          return object.straat !== "";
        }),
      },
    },
  },
  created() {
    if (this.isNew) {
      this.selectedAdres.ingangsDatum = "";
    }
    this.$emit("validation-change", true);
  },
  methods: {
    updateAdres(): void {
      this.$emit("input", this.selectedAdres);
    },
    deleteAddress(): void {
      this.$emit("delete-address");
    },
  },
  watch: {
    $v: {
      handler(value): void {
        this.$emit("validation-change", value.$invalid);
      },
      deep: true,
    },
  },
});
